/** Request header clients send to opt into Vercel UI message stream + resumable SSE. */
export const VERCEL_UI_MESSAGE_STREAM_HEADER = "x-vercel-ai-ui-message-stream";
export const VERCEL_UI_MESSAGE_STREAM_VERSION = "v1";
